import gql from 'graphql-tag'

export const DELETE_PAYMENT_METHOD_PENDING_MUTATION = gql`
  mutation DeletePaymentMethodPending($userId: Int!) {
    deletePaymentMethodPending(userId: $userId)
  }
`
